import { io } from 'socket.io-client';

const API_URL =
  process.env.REACT_APP_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? window.location.origin
    : 'http://localhost:4000');

export const socket = io(API_URL, { transports: ['websocket'] });
